// Small shared utilities for the Settings tab cards.

export const todayISO = () => new Date().toISOString().slice(0, 10);

// Read an image File, downscale to maxWidth, and return a data URL. Returns a Promise<string>.
export function resizeImageToDataURL(file, { maxWidth = 1400, type = "image/jpeg", quality = 0.82 } = {}) {
  return new Promise((resolve, reject) => {
    if (!file) { reject(new Error("No file")); return; }
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxWidth / img.width);
        const cv = document.createElement("canvas");
        cv.width = img.width * scale;
        cv.height = img.height * scale;
        cv.getContext("2d").drawImage(img, 0, 0, cv.width, cv.height);
        resolve(cv.toDataURL(type, quality));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
